import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import PasswordChangeForm from '../userManagement/PasswordChange'
import withAuthorization from '../higherOrder/withAuthorization'
import { DivWithMargin, FillerDiv } from '../StyledComponents/Fillers'

const AccountPage = ({ authUser }) =>
    (
        <DivWithMargin top="20" bottom="20">
            <FillerDiv className="card">
                <h5 className="card-header">Your account</h5>
                <FillerDiv className="card-body">
                    <h5 className="card-title">Email:</h5>
                    <p className="card-text">{authUser.email}</p>
                    <h5 className="card-title">Want to change password?</h5>
                    <PasswordChangeForm />
                </FillerDiv>
            </FillerDiv>
        </DivWithMargin>
    )

const mapStateToProps = state => ({
    authUser: state.sessionState.authUser,
})

const authCondition = authUser => !!authUser

export default compose(
    withAuthorization(authCondition),
    connect(mapStateToProps)
)(AccountPage)



// WEBPACK FOOTER //
// ./src/components/pages/Account.js